import { render, staticRenderFns } from "./savedPost.vue?vue&type=template&id=20deb9ac&"
import script from "./savedPost.vue?vue&type=script&lang=js&"
export * from "./savedPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports